module.exports = __webpack_public_path__ + "img/balkan.d409b9d8.jpg";